<template>
  <div class="value-box">
    <div class="title">
      <div>绝对估值计算</div>
      <div>（亿元）</div>
      <div>营业总收入</div>
      <div>增长率</div>
      <div>净利润（归属母公司）</div>
      <div>增长率</div>
      <div>占比（占营业收入的比例）</div>
      <div>+折旧</div>
      <div>占比（占营业收入的比例）</div>
      <div>-资本支出</div>
      <div>占比（占营业收入的比例）</div>
      <div>自由现金流（FCF）</div>
      <div>贴现后的现金流</div>
      <div>期末价值</div>
      <div>贴现后的期末价值</div>
      <div>贴现率</div>
      <div>永续增长率</div>
      <div>企业价值</div>
      <div>现金价值</div>
      <div>银行负债</div>
      <div>股票总价值</div>
      <div>流通股本数（单位：亿）</div>
      <div>股票价格</div>
    </div>
    <div class="old">
      <div>
        历史数据
      </div>
      <div>
        <div>2017A</div>
        <div>2018A</div>
        <div>2019A</div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="shouru1" placeholder="营业总收入"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="shouru2" placeholder="营业总收入"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="shouru3" placeholder="营业总收入"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="zengzhanglv1" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zengzhanglv2" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zengzhanglv3" disabled="" placeholder="增长率"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="lirun1" placeholder="净利润"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirun2" placeholder="净利润"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirun3" placeholder="净利润"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="lirunzengzhanglv1" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirunzengzhanglv2" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirunzengzhanglv3" disabled="" placeholder="增长率"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="lirunzhanbi1" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirunzhanbi2" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirunzhanbi3" disabled="" placeholder="占比"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="zhejiu1" placeholder="折旧"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhejiu2" placeholder="折旧"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhejiu3" placeholder="折旧"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="zhejiuzhanbi1" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhejiuzhanbi2" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhejiuzhanbi3" disabled="" placeholder="占比"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="zhichu1" placeholder="资本支出"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhichu2" placeholder="资本支出"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhichu3" placeholder="资本支出"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="zhichuzhanbi1" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhichuzhanbi2" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhichuzhanbi3" disabled="" placeholder="占比"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="xianjinliu1" disabled="" placeholder="自由现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="xianjinliu2" disabled="" placeholder="自由现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="xianjinliu3" disabled="" placeholder="自由现金流"></el-input>
        </div>
      </div>
      <div>
        <div>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="tiexianlv" placeholder="贴现率"></el-input>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="yongxuzengzhanglv" placeholder="永续增长率"></el-input>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="qiyejiazhi" disabled="" placeholder="企业价值"></el-input>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="xianjinjiazhi" placeholder="现金价值"></el-input>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="yinhangfuzhai" placeholder="银行负债"></el-input>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="gupiaozongjiazhi" disabled="" placeholder="股票总价值"></el-input>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="liutongguben" placeholder="流通股本（股票数量）"></el-input>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="gupiaojiage" disabled="" placeholder="股票价格"></el-input>
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>
    </div>
    <div class="new">
      <div>
        预测数据
      </div>
      <div>
        <div>2020E</div>
        <div>2021E</div>
        <div>2022E</div>
        <div>2023E</div>
        <div>2024E</div>
      </div>
     <div>
        <div>
          <el-input size="mini" v-model="shouru4" placeholder="营业总收入"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="shouru5" placeholder="营业总收入"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="shouru6" placeholder="营业总收入"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="shouru7" disabled="" placeholder="营业总收入"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="shouru8" disabled="" placeholder="营业总收入"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="zengzhanglv4" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zengzhanglv5" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zengzhanglv6" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzengzhanglv" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzengzhanglv" disabled="" placeholder="增长率"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="lirun4" placeholder="净利润"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirun5" placeholder="净利润"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirun6" placeholder="净利润"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirun7" disabled="" placeholder="净利润"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirun8" disabled="" placeholder="净利润"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="lirunzengzhanglv4" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirunzengzhanglv5" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirunzengzhanglv6" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunlirunzengzhanglv" disabled="" placeholder="增长率"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunlirunzengzhanglv" disabled="" placeholder="增长率"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="lirunzhanbi4" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirunzhanbi5" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="lirunzhanbi6" disabled="" placeholder="占比"></el-input>
        </div>
         <div>
          <el-input size="mini" v-model="pingjunlirunzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunlirunzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="zhejiu4" disabled="" placeholder="折旧"></el-input>
        </div> 
        <div>
          <el-input size="mini" v-model="zhejiu5" disabled="" placeholder="折旧"></el-input>
        </div> 
        <div>
          <el-input size="mini" v-model="zhejiu6" disabled="" placeholder="折旧"></el-input>
        </div> 
        <div>
          <el-input size="mini" v-model="zhejiu7" disabled="" placeholder="折旧"></el-input>
        </div> 
        <div>
          <el-input size="mini" v-model="zhejiu8" disabled="" placeholder="折旧"></el-input>
        </div> 
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="pingjunzhejiuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzhejiuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzhejiuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzhejiuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzhejiuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="zhichu4" disabled="" placeholder="资本支出"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhichu5" disabled="" placeholder="资本支出"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhichu6" disabled="" placeholder="资本支出"></el-input>
        </div>
         <div>
          <el-input size="mini" v-model="zhichu7" disabled="" placeholder="资本支出"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="zhichu8" disabled="" placeholder="资本支出"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="pingjunzhichuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzhichuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzhichuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzhichuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="pingjunzhichuzhanbi" disabled="" placeholder="占比"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="xianjinliu4" disabled="" placeholder="自由现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="xianjinliu5" disabled="" placeholder="自由现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="xianjinliu6" disabled="" placeholder="自由现金流"></el-input>
        </div>
         <div>
          <el-input size="mini" v-model="xianjinliu7" disabled="" placeholder="自由现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="xianjinliu8" disabled="" placeholder="自由现金流"></el-input>
        </div>
      </div>
      <div>
        <div>
          <el-input size="mini" v-model="tiexianxianjinliu4" disabled="" placeholder="贴现后现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="tiexianxianjinliu5" disabled="" placeholder="贴现后现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="tiexianxianjinliu6" disabled="" placeholder="贴现后现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="tiexianxianjinliu7" disabled="" placeholder="贴现后现金流"></el-input>
        </div>
        <div>
          <el-input size="mini" v-model="tiexianxianjinliu8" disabled="" placeholder="贴现后现金流"></el-input>
        </div>
      </div>
      <div>
        <div>
          <!-- <el-input size="mini" v-model="value.qimojiazhi4" disabled="" placeholder="期末价值"></el-input> -->
        </div>
        <div>
          <!-- <el-input size="mini" v-model="value.qimojiazhi5" disabled="" placeholder="期末价值"></el-input> -->
        </div>
        <div>
          <!-- <el-input size="mini" v-model="value.qimojiazhi6" disabled="" placeholder="期末价值"></el-input> -->
        </div>
        <div>
          <!-- <el-input size="mini" v-model="value.qimojiazhi7" disabled="" placeholder="期末价值"></el-input> -->
        </div>
        <div>
          <el-input size="mini" v-model="qimojiazhi" disabled="" placeholder="期末价值"></el-input>
        </div>
      </div>
        <div>
        <div>
        </div>
        <div>
        </div>
        <div>
        </div>
        <div>
        </div>
        <div>
          <el-input size="mini" v-model="tiexianqimojiazhi" disabled="" placeholder="贴现后期末价值"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "value_compute",
  data() {
    return {
      value:{

      },
      // 历史数据
      shouru1:'',
      shouru2:'',
      shouru3:'',
      lirun1:'',
      lirun2:'',
      lirun3:'',
      zhejiu1:'',
      zhejiu2:'',
      zhejiu3:'',
      zhichu1:'',
      zhichu2:'',
      zhichu3:'',

      // 预测数据
      shouru4:'',
      shouru5:'',
      shouru6:'',
      lirun4:'',
      lirun5:'',
      lirun6:'',

      // 贴现率   8%-15%
      tiexianlv:'',
      // 永续增长率   3%
      yongxuzengzhanglv:'',
      // 现金价值
      xianjinjiazhi:'',
      // 银行负债
      yinhangfuzhai:'',
      // 流通股本
      liutongguben:''
    };
  },
  methods: {
    
  },
  computed:{
    // 利润占比
    lirunzhanbi1(){
      if(this.lirun1&&this.shouru1){
        return (this.lirun1/this.shouru1).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzhanbi2(){
      if(this.lirun2&&this.shouru2){
        return (this.lirun2/this.shouru2).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzhanbi3(){
      if(this.lirun3&&this.shouru3){
        return (this.lirun3/this.shouru3).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzhanbi4(){
      if(this.lirun4&&this.shouru4){
        return (this.lirun4/this.shouru4).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzhanbi5(){
      if(this.lirun5&&this.shouru5){
        return (this.lirun5/this.shouru5).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzhanbi6(){
      if(this.lirun6&&this.shouru6){
        return (this.lirun6/this.shouru6).toFixed(2)
      }else{
        return ''
      }
    },
    pingjunlirunzhanbi(){
      if(this.lirunzhanbi4&&this.lirunzhanbi5&&this.lirunzhanbi6){
        return ((parseFloat(this.lirunzhanbi4)+parseFloat(this.lirunzhanbi5)+parseFloat(this.lirunzhanbi6))/3).toFixed(2)
      }else{
        return ''
      }
    },
     lirun7(){
      if(this.pingjunlirunzhanbi&&this.shouru7){
        return (this.shouru7*this.pingjunlirunzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    lirun8(){
      if(this.pingjunlirunzhanbi&&this.shouru8){
        return (this.shouru8*this.pingjunlirunzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    // 折旧占比
    zhejiuzhanbi1(){
      if(this.zhejiu1&&this.shouru1){
        return (this.zhejiu1/this.shouru1).toFixed(2)
      }else{
        return ''
      }
    },
    zhejiuzhanbi2(){
      if(this.zhejiu2&&this.shouru2){
        return (this.zhejiu2/this.shouru2).toFixed(2)
      }else{
        return ''
      }
    },
    zhejiuzhanbi3(){
      if(this.zhejiu3&&this.shouru3){
        return (this.zhejiu3/this.shouru3).toFixed(2)
      }else{
        return ''
      }
    },
    pingjunzhejiuzhanbi(){
      if(this.zhejiuzhanbi1&&this.zhejiuzhanbi2&&this.zhejiuzhanbi3){
        return ((parseFloat(this.zhejiuzhanbi1)+parseFloat(this.zhejiuzhanbi2)+parseFloat(this.zhejiuzhanbi3))/3).toFixed(2)
      }else{
        return ''
      }
    },
    zhejiu4(){
      if(this.shouru4&&this.pingjunzhejiuzhanbi){
        return (this.shouru4*this.pingjunzhejiuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    zhejiu5(){
      if(this.shouru5&&this.pingjunzhejiuzhanbi){
        return (this.shouru5*this.pingjunzhejiuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    zhejiu6(){
      if(this.shouru6&&this.pingjunzhejiuzhanbi){
        return (this.shouru6*this.pingjunzhejiuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    zhejiu7(){
      if(this.shouru7&&this.pingjunzhejiuzhanbi){
        return (this.shouru7*this.pingjunzhejiuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    zhejiu8(){
      if(this.shouru8&&this.pingjunzhejiuzhanbi){
        return (this.shouru8*this.pingjunzhejiuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    // 资本支出占比
    zhichuzhanbi1(){
      if(this.zhichu1&&this.shouru1){
        return (this.zhichu1/this.shouru1).toFixed(2)
      }else{
        return ''
      }
    },
    zhichuzhanbi2(){
      if(this.zhichu2&&this.shouru2){
        return (this.zhichu2/this.shouru2).toFixed(2)
      }else{
        return ''
      }
    },
    zhichuzhanbi3(){
      if(this.zhichu3&&this.shouru3){
        return (this.zhichu3/this.shouru3).toFixed(2)
      }else{
        return ''
      }
    },
    pingjunzhichuzhanbi(){
      if(this.zhichuzhanbi1&&this.zhichuzhanbi2&&this.zhichuzhanbi3){
        return ((parseFloat(this.zhichuzhanbi1)+parseFloat(this.zhichuzhanbi2)+parseFloat(this.zhichuzhanbi3))/3).toFixed(2)
      }else{
        return ''
      }
    },
    zhichu4(){
      if(this.shouru4&&this.pingjunzhichuzhanbi){
        return (this.shouru4*this.pingjunzhichuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    zhichu5(){
      if(this.shouru5&&this.pingjunzhichuzhanbi){
        return (this.shouru5*this.pingjunzhichuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    zhichu6(){
      if(this.shouru6&&this.pingjunzhichuzhanbi){
        return (this.shouru6*this.pingjunzhichuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    zhichu7(){
      if(this.shouru7&&this.pingjunzhichuzhanbi){
        return (this.shouru7*this.pingjunzhichuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    zhichu8(){
      if(this.shouru8&&this.pingjunzhichuzhanbi){
        return (this.shouru8*this.pingjunzhichuzhanbi).toFixed(2)
      }else{
        return ''
      }
    },
    // 营收增长率
    zengzhanglv1(){
      if(this.shouru1){
        return '-'
      }else{
        return ''
      }
    },
    zengzhanglv2(){
      if(this.shouru1&&this.shouru2){
        return ((this.shouru2-this.shouru1)/this.shouru1).toFixed(2)
      }else{
        return ''
      }
    },
    zengzhanglv3(){
      if(this.shouru2&&this.shouru3){
        return ((this.shouru3-this.shouru2)/this.shouru2).toFixed(2)
      }else{
        return ''
      }
    },
    zengzhanglv4(){
      if(this.shouru3&&this.shouru4){
        return ((this.shouru4-this.shouru3)/this.shouru3).toFixed(2)
      }else{
        return ''
      }
    },
    zengzhanglv5(){
      if(this.shouru4&&this.shouru5){
        return ((this.shouru5-this.shouru4)/this.shouru4).toFixed(2)
      }else{
        return ''
      }
    },
    zengzhanglv6(){
      if(this.shouru5&&this.shouru6){
        return ((this.shouru6-this.shouru5)/this.shouru5).toFixed(2)
      }else{
        return ''
      }
    },
    pingjunzengzhanglv(){
      if(this.zengzhanglv4&&this.zengzhanglv5&&this.zengzhanglv6){
        return ((parseFloat(this.zengzhanglv4)+parseFloat(this.zengzhanglv5)+parseFloat(this.zengzhanglv6))/3).toFixed(2)
      }else{
        return ''
      }
    },
    shouru7(){
      if(this.pingjunzengzhanglv&&this.shouru6){
        return (this.shouru6*(1+parseFloat(this.pingjunzengzhanglv))).toFixed(2)
      }else{
        return ''
      }
    },
    shouru8(){
      if(this.pingjunzengzhanglv&&this.shouru7){
        return (this.shouru7*(1+parseFloat(this.pingjunzengzhanglv))).toFixed(2)
      }else{
        return ''
      }
    },
    // 利润增长率
    lirunzengzhanglv1(){
      if(this.lirun1){
        return '-'
      }else{
        return ''
      }
    },
    lirunzengzhanglv2(){
      if(this.lirun1&&this.lirun2){
        return ((this.lirun2-this.lirun1)/this.lirun1).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzengzhanglv3(){
      if(this.lirun2&&this.lirun3){
        return ((this.lirun3-this.lirun2)/this.lirun2).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzengzhanglv4(){
      if(this.lirun3&&this.lirun4){
        return ((this.lirun4-this.lirun3)/this.lirun3).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzengzhanglv5(){
      if(this.lirun4&&this.lirun5){
        return ((this.lirun5-this.lirun4)/this.lirun4).toFixed(2)
      }else{
        return ''
      }
    },
    lirunzengzhanglv6(){
      if(this.lirun5&&this.lirun6){
        return ((this.lirun6-this.lirun5)/this.lirun5).toFixed(2)
      }else{
        return ''
      }
    },
    pingjunlirunzengzhanglv(){
      if(this.lirunzengzhanglv4&&this.lirunzengzhanglv5&&this.lirunzengzhanglv6){
        return ((parseFloat(this.lirunzengzhanglv4)+parseFloat(this.lirunzengzhanglv5)+parseFloat(this.lirunzengzhanglv6))/3).toFixed(2)
      }else{
        return ''
      }
    },
    // 自由现金流
    xianjinliu1(){
      if(this.lirun1&&this.zhejiu1&&this.zhichu1){
        return (parseFloat(this.lirun1) + parseFloat(this.zhejiu1) - this.zhichu1).toFixed(2) 
      }else{
        return ''
      }
    },
    xianjinliu2(){
      if(this.lirun2&&this.zhejiu2&&this.zhichu2){
        return (parseFloat(this.lirun2) + parseFloat(this.zhejiu2) - this.zhichu2).toFixed(2) 
      }else{
        return ''
      }
    },
    xianjinliu3(){
      if(this.lirun3&&this.zhejiu3&&this.zhichu3){
        return (parseFloat(this.lirun3) + parseFloat(this.zhejiu3) - this.zhichu3).toFixed(2) 
      }else{
        return ''
      }
    },
    xianjinliu4(){
      if(this.lirun4&&this.zhejiu4&&this.zhichu4){
        return (parseFloat(this.lirun4) + parseFloat(this.zhejiu4) - this.zhichu4).toFixed(2) 
      }else{
        return ''
      }
    },
    xianjinliu5(){
      if(this.lirun5&&this.zhejiu5&&this.zhichu5){
        return (parseFloat(this.lirun5) + parseFloat(this.zhejiu5) - this.zhichu5).toFixed(2) 
      }else{
        return ''
      }
    },
    xianjinliu6(){
      if(this.lirun6&&this.zhejiu6&&this.zhichu6){
        return (parseFloat(this.lirun6) + parseFloat(this.zhejiu6) - this.zhichu6).toFixed(2) 
      }else{
        return ''
      }
    },
    xianjinliu7(){
      if(this.lirun7&&this.zhejiu7&&this.zhichu7){
        return (parseFloat(this.lirun7) + parseFloat(this.zhejiu7) - this.zhichu7).toFixed(2) 
      }else{
        return ''
      }
    },
    xianjinliu8(){
      if(this.lirun8&&this.zhejiu8&&this.zhichu8){
        return (parseFloat(this.lirun8) + parseFloat(this.zhejiu8) - this.zhichu8).toFixed(2) 
      }else{
        return ''
      }
    },
    // 贴现后现金流
    tiexianxianjinliu4(){
      if(this.xianjinliu4&&this.tiexianlv){
        return (this.xianjinliu4/(1+parseFloat(this.tiexianlv))).toFixed(2)
      }else{
        return ''
      }
    },
    tiexianxianjinliu5(){
      if(this.xianjinliu5&&this.tiexianlv){
        return (this.xianjinliu5/Math.pow((1+parseFloat(this.tiexianlv)),2)).toFixed(2)
      }else{
        return ''
      }
    },
    tiexianxianjinliu6(){
      if(this.xianjinliu6&&this.tiexianlv){
        return (this.xianjinliu6/Math.pow((1+parseFloat(this.tiexianlv)),3)).toFixed(2)
      }else{
        return ''
      }
    },
    tiexianxianjinliu7(){
      if(this.xianjinliu7&&this.tiexianlv){
        return (this.xianjinliu7/Math.pow((1+parseFloat(this.tiexianlv)),4)).toFixed(2)
      }else{
        return ''
      }
    },
    tiexianxianjinliu8(){
      if(this.xianjinliu8&&this.tiexianlv){
        return (this.xianjinliu8/Math.pow((1+parseFloat(this.tiexianlv)),5)).toFixed(2)
      }else{
        return ''
      }
    },
    // 贴现后期末价值
    tiexianqimojiazhi(){
      if(this.qimojiazhi&&this.tiexianlv){
        return (this.qimojiazhi/Math.pow((1+parseFloat(this.tiexianlv)),5)).toFixed(2)
      }else{
        return ''
      }
    },
    // 期末价值  = 第五年的自由现金流*（1+永续增长率）/（贴现率-永续增长率）
    qimojiazhi(){
      if(this.xianjinliu8&&this.yongxuzengzhanglv&&this.tiexianlv){
        return (this.xianjinliu8*(1+parseFloat(this.yongxuzengzhanglv))/(this.tiexianlv-this.yongxuzengzhanglv)).toFixed(2)
      }else{
        return ''
      }
    },
    // 企业价值  5年贴现后现金流+贴现后的期末价值
    qiyejiazhi(){
      if(this.tiexianxianjinliu4&&this.tiexianxianjinliu5&&this.tiexianxianjinliu6&&this.tiexianxianjinliu7&&this.tiexianxianjinliu8&&this.tiexianqimojiazhi){
        return (parseFloat(this.tiexianxianjinliu4)+parseFloat(this.tiexianxianjinliu5)+parseFloat(this.tiexianxianjinliu6)+parseFloat(this.tiexianxianjinliu7)+parseFloat(this.tiexianxianjinliu8)+parseFloat(this.tiexianqimojiazhi)).toFixed(2)
      }else{
        return ''
      }
    },
    // 股票总价值  企业价值-银行负债+现金价值
    gupiaozongjiazhi(){
      if(this.qiyejiazhi&&this.yinhangfuzhai&&this.xianjinjiazhi){
        return this.qiyejiazhi -this.yinhangfuzhai+parseFloat(this.xianjinjiazhi)
      }else{
        return ''
      }
    },
    // 股票价格
    gupiaojiage(){
      if(this.gupiaozongjiazhi&&this.liutongguben){
        return (this.gupiaozongjiazhi/this.liutongguben).toFixed(2)
      }else{
        return ''
      }
    }
  },
  created() {
  }
};
</script>
<style lang="scss">
.value-box{
  overflow:hidden;
  div{
    margin-bottom:12px;
  }
  &>div{
    float:left;
    overflow:hidden;
  }
  .title{
    &>div{
      height:30px;
      line-height:30px;
    }
  }
  .old,.new{
    &>div{
      height:30px;
      line-height:30px;
      overflow:hidden;
      &>div{
        float:left;
        width:100px;
        padding:0 6px;
      }
    }
  }
}
</style>
